import { createFileRoute } from '@tanstack/react-router'
import {UserProfile} from "@descope/react-sdk";
import { usePageTitle } from '../../features/page-title/pageTitle'

export const Route = createFileRoute('/me/account')({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTitle('Account')
  return <UserProfile
	  widgetId="user-authentication-widget"
  />
}
